/*
* Override search function to return more results
* */
document.addEventListener('DOMContentLoaded', function () {

    let PreductiveSearchCustomElement = window.customElements.get('predictive-search-element');

    PreductiveSearchCustomElement.prototype.getSearchResults = async function(t){

        this.abort_controller && this.abort_controller.abort();
        var e = t.trim();
        if (this.cached_results[e]) this.results.innerHTML = this.cached_results[e]; else {
            this.abort_controller = new AbortController, this.toggleLoading(!0);
            try {
                var i = await fetch(`${Shopify.routes.predictive_search}?q=${encodeURIComponent(t)}&section_id=predictive-search&resources[limit]=8&resources[limit_scope]=each&resources[options][fields]=title,vendor,product_type,variants.title,variants.sku`, {signal: this.abort_controller.signal});
                if (!i.ok) throw new Error(i.status);
                var s = (await i.text()).parse().innerHTML;
                this.cached_results[e] = s, this.results.innerHTML = s
            } catch {
            }
        }
    }

});/*
* Override search function to return more results
* */
document.addEventListener('DOMContentLoaded', function () {

    let CartCustomElement = window.customElements.get('cart-element');

    CartCustomElement.addItems = async function(t = {}, ...e){

        const Cart = this;
        document.querySelectorAll('.quantity-selector--error').forEach(function(item){ item.remove(); })


        var i = await fetch(Shopify.routes.cart_add + ".js", t);

        if (!i.ok){

            // const error = await i.json();
            const cartError = JSON.parse(await i.text());

            window.dispatchEvent(new CustomEvent('theme:cart:error', {detail: {cart: Cart, error: cartError}}));
            // console.log('i.statusText', i.statusText);
            throw new Error(i.statusText);
        }

        CartCustomElement.fetchTotals();
        var s = (await i.json())["sections"];
        Cart.updateAllHtml(s, !0), e.forEach(t => window.trigger("theme:cart:productAdded", t))
    }

    CartCustomElement.prototype.tryToUpdateQuantity =  async function(t, e) {

        const Cart = this;
        this.toggleLoadingDisplay(!1, t);
        try {
            await this.updateQuantity(t, e);
            return;
        } catch (e) {
            console.log('myTry catch error intrytoupdates:', e);
        }
    }

    CartCustomElement.prototype.updateQuantity = async function(t, e) {

        const Cart = this;

        this.abort_controllers.line_num && this.abort_controllers.line_num.abort(), this.abort_controllers.line_num = new AbortController;
        var i = this.querySelector(`.cart--item[data-line-num='${t}']`), {
                management: s,
                policy: r,
                quantity: o
            } = i.dataset, a = parseInt(o), n = i.getAttribute("data-variant-id"), l = this.getOtherVariantQuantities(i, n),
            h = a < e + l && "shopify" === s && "continue" !== r;
        h && (e = a - l);
        try {
            var c, d = await fetch(Shopify.routes.cart_change + ".js", {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({line: t, quantity: e, sections: CartCustomElement.sections}),

            });
            if (d.ok){

                const eventElement = document.activeElement;
                // Get the quantity selector container
                const theForm = eventElement.closest("form");

                if (theForm){

                    const quantitySelectorContainer = theForm.querySelector(".quantity-selector--container");
                    const checkoutButton = theForm.querySelector(".cart--checkout-button");

                    document.querySelectorAll('.quantity-selector--error').forEach(function(item){ item.remove(); })


                    checkoutButton.disabled = false;
                    quantitySelectorContainer.querySelector('.quantity-selector--input').dataset.loading = "";
                }


                return CartCustomElement.fetchTotals(), c = (await d.json())["sections"], CartCustomElement.updateAllHtml(c), !h;


            }

            const cartError = JSON.parse(await d.text());
            window.dispatchEvent(new CustomEvent('theme:cart:error', {detail: {cart: Cart, error: cartError}}));
            throw new Error(cartError.message);
            
        } catch (err) {
            if (err.name === 'AbortError') {
                throw new Error("aborted");
            }
            throw err; // Re-throw the actual error instead of forcing "aborted"
        }

    }


});

window.addEventListener('theme:cart:error', function (e) {

    const eventElement = document.activeElement;

    // Get the quantity selector container`
    const quantitySelectorContainer = eventElement.closest("form").querySelector(".quantity-selector--container");
    const checkoutButton = eventElement.closest("form").querySelector(".cart--checkout-button");

    if (quantitySelectorContainer) {
        // Remove any existing error messages
        const existingError = quantitySelectorContainer.nextElementSibling;
        if (existingError && existingError.classList.contains("quantity-selector--error")) {
            existingError.remove();
        }

        // Create and insert new error message div
        const errorDiv = document.createElement("div");
        errorDiv.className = "quantity-selector--error";
        errorDiv.setAttribute("role", "alert");
        errorDiv.textContent = e.detail?.error?.message  || "An error occurred. Please try again.";

        quantitySelectorContainer.insertAdjacentElement("afterend", errorDiv);

        // Optional: Auto-remove error after 5 seconds
        // setTimeout(() => errorDiv.remove(), 6000);

        
        checkoutButton.disabled = false;
        quantitySelectorContainer.querySelector('.quantity-selector--input').dataset.loading = "";



    }


})

document.addEventListener('DOMContentLoaded', function () {

    window.addEventListener('theme:cart:updated', function (e) {

        const cartElement = e.detail;
        const isProductTemplate = document.body.classList.contains('template--product');
        const hasSubscriptionWidget = document.querySelector('.main-product--form recharge-subscription-widget') !== null;
        const isGroupedProduct = document.querySelector('.variant-quantities-wrapper') !== null;

        subItems = cartElement.querySelectorAll('.cart--item--selling-plan');

        // if the current product is sub product - then potentially disable adding it to cart
        // fetch the latest version of the cart - to ensure that the last delete/add action has completed

        fetch('/cart.js')
            .then(response => response.json())
            .then(shopifyCart => {

                // Handle updated shopifyCart data

                if (isProductTemplate && hasSubscriptionWidget && !isGroupedProduct) {
                    // get all the product-buy-buttons-element elements and work out if that product is in the cart already
                    // - if it is then dsable the add to basket

                    document.querySelectorAll('product-buy-buttons-element').forEach(button => {

                        const productId = button.closest('form').dataset.productid;
                        const idsInCart = shopifyCart.items.map(item => item.product_id.toString() );

                        if (idsInCart.includes( productId ) && ! isGroupedProduct){
                            button.querySelector('button').disabled = true;
                            button.querySelector('span').innerText = 'Already in basket';
                        }else{
                            button.querySelector('button').removeAttribute('disabled');
                            button.querySelector('span').innerText = 'Add to basket';
                        }
                    });
                }
            });
    });
});

document.addEventListener('DOMContentLoaded', function () {

   let QuantitySelectorCustomElement = window.customElements.get('quantity-selector');

   QuantitySelectorCustomElement.prototype.callback = function(t){

       const min = t === 0 ? 0 : parseInt(this.dataset.min) || 1;
       const max = parseInt(this.dataset.max) || Infinity;
       const increment = parseInt(this.dataset.increment) || 1;

       let validatedValue = t;
       const activeEl = document.activeElement;

       // Check if (Value - Min) obeys the increment rule
       if ((validatedValue - min) % increment !== 0) {
           const steps = (validatedValue - min) / increment;

           if (activeEl && activeEl.classList.contains('quantity-selector--plus')) {
               // User clicked PLUS: Jump to the next valid increment
               validatedValue = min + Math.ceil(steps) * increment;
           } else if (activeEl && activeEl.classList.contains('quantity-selector--minus')) {
               // User clicked MINUS: Jump down to the previous valid increment
               validatedValue = min + Math.floor(steps) * increment;
           } else {
               // Fallback for typing/blur: Round to the nearest valid step
               validatedValue = min + Math.round(steps) * increment;
           }
       }

       // Ensure final value is within min/max bounds
       validatedValue = Math.max(min, Math.min(max, validatedValue));

       // Update the UI if validation changed the requested value
       if (validatedValue !== t) {
           this.input.value = validatedValue;
       }
console.log('this.line_num', this.line_num);
       "cart" === this.type ? this.cart.tryToUpdateQuantity(this.line_num, validatedValue) : "product" === this.type && window.trigger(`theme:product:${this.dataset.id}:quantityChanged`, validatedValue);

       // console.log('Final validated quantity:', validatedValue);

   } ;

});

// Style Shopify forms
customElements.whenDefined('shopify-forms-embed').then(() => {
  const observer = new MutationObserver(() => {
    const widgets = document.querySelectorAll('shopify-forms-embed');

    widgets.forEach((widget) => {
      // Skip if already processed
      if (widget.dataset.styled) return;

      const shadowRoot = widget.shadowRoot;
      if (!shadowRoot) return;

      const sheet = new CSSStyleSheet();

      sheet.replaceSync(`
        :host {
          --inline-container-max-width: 600px;
          --form-field-border-radius: 0;
          --button-border-radius: 0;
        }

        #form-container-ref h2 {
          margin-bottom: 16px;
          font-size: var(--font--section--size);
          line-height: var(--font--line-height);
          font-weight: var(--font--heading--weight);
        }

        #form-container-ref p {
          font-size: 16px;
        }

        #form-container-ref [class*='formContainer'] {
          margin: 0;
          padding: 0 16px;
        }

        #form-container-ref form {
          gap: 20px;
          padding: 0;
          width: 600px;
          max-width: 100%;
          text-align: left;
          box-sizing: border-box;
        }

        #form-container-ref input {
          color: var(--color--body);
          font-size: 16px;
        }

        #form-container-ref legend {
          font-size: 16px;
        }

        #form-container-ref [class*='selectToggle'] {
          height: 51px;
          max-height: 51px;
        }

        #form-container-ref button[type="submit"] {
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        #form-container-ref [class*='formDisclaimer'] p {
          font-size: 12px;
        }

        [class*='formBannerContainer'] [class*='formBannerHeading'] {
          margin-bottom: 16px;
          font-size: var(--font--section--size);
          line-height: var(--font--line-height);
          font-weight: var(--font--heading--weight);
        } 

        [class*='formBannerContainer'] p {
          font-size: 16px;
        } 
      `);

      shadowRoot.adoptedStyleSheets.push(sheet);

      // Mark as processed
      widget.dataset.styled = "true";
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
